export default __webpack_public_path__ + "static/media/Icon-Refine.26852de7.svg";